import { render } from "./PlatformClientManagement.vue?vue&type=template&id=6b7faf8a&scoped=true"
import script from "./PlatformClientManagement.vue?vue&type=script&lang=js"
export * from "./PlatformClientManagement.vue?vue&type=script&lang=js"

import "./PlatformClientManagement.vue?vue&type=style&index=0&id=6b7faf8a&scoped=true&lang=css"
import "./PlatformClientManagement.vue?vue&type=style&index=1&id=6b7faf8a&lang=css"

import exportComponent from "/codebuild/output/src710843524/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7faf8a"]])

export default __exports__